<template>
<div class="ipad" id="app">
   <div class="frame">
       <div :class="infoBoxStyle"
       id="alert"
             dismissible
             v-if="showDismissibleAlert"
             >
              <span @click="dismiss()" class="x">&#10005;</span> 
             <span class="header" v-if="currentScreen.title">{{currentScreen.title}}</span>
             <span class="content" v-html="currentScreen.text"></span>
    </div>
    <div class="router" > <router-view>
     </router-view>
     <div class="tutorial" v-if="isHelpShown" @click="closeHelp()">
       <div class="tutorialHilight"></div>
        </div>
     </div>
   <b-navbar class="nav bg" toggleable="md" type="dark" >
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_collapse" class="collapse">
      <div class="logoItem">
<b-navbar-brand class="logo" to="/home" >
      
      <h4>SAP C/4HANA</h4>
      
      <h2>Start your <br>
      <span>Omnichannel <br> Customer <br> Experience</span> <br> Journey <br></h2>
      <br>
    </b-navbar-brand>
    <div class="menuItems">
      <template v-for="(m,i) in chapters" >
      <b-navbar-brand :key="i" class="brand"
                      :class="{'active' : isPathOrNestedPathActive(m.chapterId)}"
                      :to="{name:'chapter.screen', 
                      params:{ chapterId: m.chapterId,  
                      screenId: m.storyboardScreens[0] ? m.storyboardScreens[0].screenId:'none', 
                      screenImagesFolderName:m.screenImagesFolderName, 
                      storyboardScreens:m.storyboardScreens}}"> 
                      <navbar-number v-if="!m.showBulb" :text="m.name" :number="m.number" ></navbar-number>
                      <navbar-learn-more :text="m.name" :line-per-word="m.showBulb && !topBarIsShown" v-else></navbar-learn-more>
                       </b-navbar-brand>
      </template>

  </div>
  
    </div>
    </b-collapse>
</b-navbar>
</div>
</div>
</template>
<script>
const routesToAutoNavigate = [
  "SeeIt",
  "Offer",
  "Store",
  "Shop",
  "Buy",
  "Share",
  "LearnMore"
];
import NavbarLearnMore from "@/views/NavbarLearnMore";
import NavbarNumber from "@/views/NavbarNumber";
import { mapGetters } from "vuex";
export default {
  components: {
    navbarNumber: NavbarNumber,
    navbarLearnMore: NavbarLearnMore
  },
  data() {
    return {
      indexOfPicture: 0,
      infoBoxStyle: ""
    };
  },
  methods: {
    isPathOrNestedPathActive(chapterId) {
      let indexOfChapterId = this.$route.fullPath.indexOf(chapterId);
      return indexOfChapterId > -1;
    },
    closeHelp() {
      this.$store.commit("IS_HELP_HIDEN");
    },
    dismiss() {
      this.$store.commit("HIDE_ALLERT");
    }
  },
  mounted() {
    this.$router.push("/home");
    this.$store.commit("HIDE_ALLERT");
  },
  computed: {
    ...mapGetters([
      "showDismissibleAlert",
      "currentScreen",
      "chapters",
      "isHelpShown",
      "topBarIsShown",
      "infoBoxPositin"
    ])
   
  },
  watch: {
    $route(to, from) {
      this.$store.commit("IS_HELP_HIDEN");
      this.$store.commit("SET_CURRENT_SCREEN", this.$route.params.screenId);
    },
    currentScreen(newValue) {
      if (this.currentScreen) {
        
        if (newValue.highlightPosition == "Top-Left") {
          this.infoBoxStyle = "alertLeft";
        } else {
          this.infoBoxStyle = "alert";
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.tutorial {
  z-index: 2000;
  position: absolute;
  top: 0;
  background: url("./image/TUTORIAL.png");
  width: 1024px;
  height: 689px;
  background-size: 1024px 689px;
}
.tutorialHilight {
  z-index: 2001;
  opacity: 0;
  position: absolute;
  bottom: 0;
  right: 0;
  background: url("./image/next.png");
  width: 177px;
  height: 177px;
  background-size: 177px 177px;
  animation-name: fadein;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.x {
  margin-left: 23px;
  margin-top: 13px;
  font-size: 12px;
  height: 14px;
  width: 14px;
  font-weight: 100;
}
.x:hover {
  cursor: pointer;
}
.content {
  width: 325px;
  height: 56px;
  font-family: BentonSans-Regular;
  margin-left: 59px;
  margin-top: 2px;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: #ffffff;
  text-align: start;
}
.header {
  text-align: start;
  margin-left: 59px;
  margin-top: 7px;
  width: 270px;
  height: 32px;
  font-family: BentonSansBold;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.83;
  letter-spacing: 1px;
  color: #ffffff;
}
.alert {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  position: absolute;
  z-index: 1000;
  bottom: 539px;
  left: 573px;
  border-right: 10px solid #f6b63a;
  background: black;
  color: #ffffff;
  width: 451px;
  height: 171px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  align-items: baseline;
}
.alertLeft {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  position: absolute;
  z-index: 1000;
  bottom: 539px;
  left: 0px;
  border-right: 10px solid #f6b63a;
  background: black;
  color: #ffffff;
  width: 451px;
  height: 171px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  align-items: baseline;
}
@media screen and (max-width: 1023px) {
  body {
    align-items: flex-end;
  }
  #portrait {
    display: block;
    padding: 15px;
    display: block;
    color: azure;
    font-size: 26px;
  }
  #app {
    display: none;
  }
}
@font-face {
  font-family: BentonSans;
  src: url("./fonts/BentonSans-Medium.otf") format("opentype");
}
@font-face {
  font-family: BentonSans-Regular;
  src: url("./fonts/BentonSans-Regular.otf") format("opentype");
}
@font-face {
  font-family: BentonSansBold;
  font-weight: bold;
  src: url("./fonts/BentonSans-Bold.otf") format("opentype");
}
* {
  transition: all 0.4s ease;
  box-sizing: border-box;
}

.router {
  height: 689px;
  display: flex;
  justify-content: center;
}

.menuItems {
  float: left;
  height: 59px;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-self: flex-end;
  background-color: #000000;
  justify-content: flex-start;
  align-items: center;

  .brand {
    margin: 0;
    padding: 0;
    height: 59px;
    width: 98.5px;
    flex-grow: 1;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    .bulb {
      transform: rotate(180deg);
    }
    .number {
      width: 33px;
      height: 32px;
      opacity: 0.16;
      font-weight: 900;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1.2px;
      text-align: center;
      font-size: 22px;
      color: rgb(255, 255, 255);
    }
    .textSize {
      height: 17px;
      letter-spacing: 1.7px;
      font-size: 12px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      color: #fff;
    }
    float: left;
    position: relative;
  }
}
.logoItem {
  //overflow: visible;
  overflow: hidden;
  position: absolute;
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  flex-grow: 1;
}
#app {
  font-family: "BentonSansBold";
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  background-color: rgb(8, 1, 1);
}
h6,
h2 {
  font-family: "BentonSansBold";
  letter-spacing: 1px;
  line-height: 18px;
  span {
    color: #fab82c;
  }
}

.brand:hover h6 .number {
  opacity: 1;
  color: #fab82c;
}

.brand:hover h6 .bulb {
  opacity: 1;
  color: #fab82c;
}
.brand:hover h6 .textSize {
  color: #fab82c;
}
.active.brand:hover h6 .textSize {
  color: #ffffff;
}
.logo {
  background-color: #000000;
  h2 {
    opacity: 0;
    span {
      opacity: 0;
      color: #fab82c;
    }
  }
}
.bg {
  background-color: black !important;
}
.topBar {
  height: 38px;
  display: flex;
  flex-direction: row;
  background: black !important;
  justify-content: flex-end;
  align-content: center;
  align-items: flex-end;
  margin: 0;
  padding-right: 20px;
  padding-bottom: 10px;
  padding: 0;
}

.logo {
  padding-left: 40px;
  text-align: left;
  height: 59px;
  float: left;
  position: relative;
  width: 216px;
  margin: 0;
}
.frame {
  position: relative;
  width: 1024px;
  height: 748px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
#nav_collapse {
  align-self: flex-end;
}
.logo h4 {
  object-fit: contain;
  margin-left: -8px;
  margin-bottom: 3px;
  margin-top: 12px;
  width: 168px;
  height: 55px;
      font-size: 20px;
}
.ipad {
  display: flex;
  height: 748px;
  width: 1024px;
  background-size: 1024px 768px;
  justify-content: flex-end;
  align-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
}

@media (min-width: 1201px) {
  .ipad {
    display: flex;
    background-image: url(./image/iPd-Frame.png);
    background-repeat: no-repeat;
    height: 940px;
    width: 1268px;
    background-size: 1268px 940px;
    justify-content: center;
    align-content: center;
    align-items: center;
    align-self: flex-start;
  }
}
.active.logo + .menuItems {
  height: 192px;
  width: 657;
  .brand {
    height: 192px;
    width: 94px;
  }
}
.active.logo {
  border-right: 1px solid #212121;
  border-left: 10px solid #fab82c;
  width: 366px;
  height: 370px;
  background-color: #000000;
  justify-content: center;
  align-items: center;
  font-size: 30px;

  h2 {
    opacity: 1;
    line-height: 33px;
    margin-top: 5px;
    left: 72px;
    display: block;
    font-size: 30px;
    letter-spacing: 1.7px;
    span {
      opacity: 1;
      font-family: BentonSansBold;
      font-size: 30px;
    }
  }

  h4 {
    object-fit: contain;
    margin-left: 0px;
    margin-top: 37px;
    margin-right: 90px;
    width: 225px;
    height: 65px;
  }
}

.active.brand {
  display: flex;
  border-top: 5px solid #fab82c;
  border-right: 0.1px solid rgba(151, 151, 151, 0.4);
  border-left: 0.1px solid rgba(151, 151, 151, 0.4);
  justify-content: center;
  align-items: center;
  width: 217px;

  h6 {
    .textSize {
      opacity: 1;
      letter-spacing: 2.8px;
      font-size: 20px;
      color: #fff;
    }
    .bulb {
      margin-right: 20px;
      margin-top: 5px;
      color: #fab82c;
    }
    .number {
      opacity: 1;
      letter-spacing: 1.2px;
      font-size: 22px;
      color: #fab82c;
      margin-right: 20px;
    }
    br {
      display: none;
    }
  }
}

.nav {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  height: 59px;
}
</style>
